import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import { defineComponent, toRefs, reactive, ref, watch, computed } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { Loading } from "@element-plus/icons";
import Head from "@/components/Head/index.vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "ProblemIndex",
  components: {
    Head: Head,
    Loading: Loading
  },
  setup: function setup() {
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var loading = ref(false);
    var PaginationInit = ref(false); // 搜索条件

    var searchValue = reactive({
      pageIndex: 1,
      pageSize: 3,
      status: 0,
      param: ""
    }); // 切换变化的值

    var switchIdentity = reactive({
      currentTabIndex1: 0,
      currentTabIndex2: 0
    }); // 数据列表信息

    var dataList = reactive({
      listData: [],
      totalNum: 0
    }); //tabs 分类

    var classification = reactive({
      firstTabs: [{
        name: "正在进行"
      }, {
        name: "历史记录"
      }],
      secondTabs: [[{
        name: "全部",
        value: 0
      }, {
        name: "我的上报",
        value: 1
      }, {
        name: "待我处理",
        value: 2
      }], [{
        name: "全部",
        value: 3
      }, {
        name: "已解决",
        value: 4
      }, {
        name: "已过期",
        value: 5
      }, {
        name: "已驳回",
        value: 6
      }]]
    });
    getTabledata(); // 身份颜色

    var identityColor = computed(function () {
      return function (identity) {
        var color = '224, 31, 32';

        if (identity == 2) {
          color = '245, 164, 38';
        }

        if (identity == 3) {
          color = '89, 127, 202';
        }

        return color;
      };
    }); // 处理状态颜色

    var stateColor = computed(function () {
      return function (item) {
        var obj = {
          color: "224, 31, 32",
          name: ""
        };

        if (item.state == 0 || [1, 2, 3].includes(item.status)) {
          obj.color = '245, 164, 38';
          obj.name = "待受理";
        }

        if (item.processStatus == 1) {
          obj.color = '5, 182, 147'; //已解决

          obj.name = "已解决";
        }

        if (item.processStatus == 2) {
          obj.color = '144, 147, 153'; //已过期

          obj.name = "已过期";
        }

        if (item.state == 2) {
          obj.color = '224, 31, 32'; //已驳回

          obj.name = "已驳回";
        }

        if (item.status == 6) {
          obj.name = "待开始";
        }

        return obj;
      };
    }); // 搜索

    function searchByName() {
      return _searchByName.apply(this, arguments);
    }

    function _searchByName() {
      _searchByName = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                getTabledata();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _searchByName.apply(this, arguments);
    }

    function getTabledata() {
      return _getTabledata.apply(this, arguments);
    } // 翻页


    function _getTabledata() {
      _getTabledata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dataList.listData = [];
                loading.value = false;
                _context2.next = 4;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getProblemReportingList"](searchValue);

              case 4:
                res = _context2.sent;

                if (res.code == 0) {
                  dataList.listData = res.data;
                  dataList.totalNum = res.total;
                  loading.value = true;
                  PaginationInit.value = true;
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getTabledata.apply(this, arguments);
    }

    function changPage(_x) {
      return _changPage.apply(this, arguments);
    } // 第一行tabs切换


    function _changPage() {
      _changPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(val) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                searchValue.pageIndex = val;
                getTabledata();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _changPage.apply(this, arguments);
    }

    function getFirstIndex(_x2) {
      return _getFirstIndex.apply(this, arguments);
    } //第二行tabs切换


    function _getFirstIndex() {
      _getFirstIndex = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(index) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                PaginationInit.value = false;
                switchIdentity.currentTabIndex1 = index;
                switchIdentity.currentTabIndex2 = 0;
                searchValue.pageIndex = 1;
                searchValue.status = classification.secondTabs[index][0].value;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _getFirstIndex.apply(this, arguments);
    }

    function getSecondIndex(_x3) {
      return _getSecondIndex.apply(this, arguments);
    } // 跳转详情页


    function _getSecondIndex() {
      _getSecondIndex = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(index) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                PaginationInit.value = false;
                switchIdentity.currentTabIndex2 = index;
                searchValue.pageIndex = 1;
                searchValue.status = classification.secondTabs[switchIdentity.currentTabIndex1][index].value;

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _getSecondIndex.apply(this, arguments);
    }

    function toPage(id) {
      if (id) {
        router.push({
          name: "problemDetails",
          query: {
            id: id
          }
        });
      } else {
        router.push({
          name: "problemAdd"
        });
      }
    } // 监听tabs索引值改变


    watch(switchIdentity, function () {
      getTabledata();
    });
    watch(function () {
      return router.currentRoute.value.path;
    }, function (newValue, oldValue) {
      if (oldValue == "/personal/problemAdd") {
        searchValue.pageIndex = 1;
        searchValue.status = 0;
        searchValue.param = "";

        if (switchIdentity.currentTabIndex1 == 0 && switchIdentity.currentTabIndex2 == 0) {
          getTabledata();
        }

        switchIdentity.currentTabIndex1 = 0;
        switchIdentity.currentTabIndex2 = 0;
      } else if (newValue == '/personal/problemReporting') {
        getTabledata();
      }
    });
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      loading: loading,
      identityColor: identityColor,
      stateColor: stateColor,
      PaginationInit: PaginationInit,
      changPage: changPage,
      getFirstIndex: getFirstIndex,
      getSecondIndex: getSecondIndex
    }, toRefs(dataList)), toRefs(searchValue)), toRefs(switchIdentity)), toRefs(classification)), {}, {
      searchByName: searchByName,
      toPage: toPage
    });
  }
});